import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  ssDialogService,
} from 'app/services';

import controller from './schematic-section.controller';
import directive from './schematic-section.directive';
import schematic from './schematic';
import editSchematicDialog from './dialog.editSchematicDialog';
import uploadSchematicsDialog from './dialog.uploadSchematicsDialog';

export default angular.module('app.components.advisory.bcp.schematicSection', [
  bcpDataService,
  constants,
  ssDialogService,
  schematic,
  editSchematicDialog,
  uploadSchematicsDialog
])
  .directive('bcpSchematicSection', directive)
  .controller('SchematicSectionController', controller)
  .name;

console.log('app.components.advisory.bcp.schematicSection created');
